module.exports = __webpack_public_path__ + "images/emoji/hourglass.59704916733df5ba5a9d.png";